export enum OrderStatus {
  Draft = 'draft',
  Save = 'save',
  SaveToList = 'save-to-list',
  Quote = 'quote',
  DepositPaying = 'deposit-now-paying',
  DepositToken = 'deposit-now-token', // FIXME: can we remove? doesnt make it to DB
  DepositCharged = 'deposit-now-charged',
  DepositPayLater = 'deposit-later',
  ExternalCheckout = 'external-checkout',
  Popup = 'popup',
  /**
   * Undefined is set when client-side print is triggered and we don't have an OrderStatus set in the state yet.
   * this is necessary as different parts of our print functionality use resources from different status when the same is undefined.
   * E.g.:
   *  - emailFormat in CommonEmail.tsx is set as checkoutEmailFormat when order status is undefined
   *  - quoteInformationType in PrintAdditionalInformation.tsx is used when order status is undefined
   */
  Undefined = 'undefined',
}
